import {Injectable} from "@angular/core";
import {DeleteDeliveryPointUseCase} from "@app/core/delivery-point/application/delete-delivery-point.use-case";
import {Observable} from "rxjs";
import {PopupNotifier} from "@app/presentation/components/errors/popup.notifier";
import {onError} from "@app/presentation/rxjs-utils/operators/on-error";
import {take} from "rxjs/operators";
import {onIsLoadingChanges} from "@app/presentation/rxjs-utils/operators/on-is-loading-changes";
import {createStatusStore} from "@app/presentation/rxjs-utils/create-status-store";

@Injectable({
    providedIn: 'root'
})
export class DeleteDeliveryPointViewModel {

    notifier = new PopupNotifier();

    private deleteDeliveryPointStatus = createStatusStore();
    readonly isDeleteDeliveryPointLoading$ = this.deleteDeliveryPointStatus.isLoading$;

    constructor(private deleteDeliveryPointUseCase: DeleteDeliveryPointUseCase) { }

    deleteDeliveryPoint(deliveryPointCode: number): Observable<void> {
        return this.deleteDeliveryPointUseCase.execute(deliveryPointCode).pipe(
            take(1),
            onIsLoadingChanges(this.deleteDeliveryPointStatus.setIsLoading),
            onError(error => this.notifier.notifyError(error))
        );
    }
}
